import {
  FETCH_EVENT_LIST,
  FETCH_EVENT_LIST_DONE,
  FETCH_EVENT_LIST_ERROR,
  FETCH_EVENT_DETAILS_DONE,
  FETCH_EVENT_TYPES_DONE,
  FETCH_EVENT_STATUS_DONE,
  FETCH_EVENT_PRODUCTS,
  FETCH_EVENT_PRODUCTS_DONE,
  FETCH_EVENT_PRODUCTS_ERROR,
  STORE_SELECTED_PRODUCT,
  CLEAR_EVENT_DETAILS,
  CLEAR_EVENT_STATUS
} from "./constants";

const initialState = {
  events: {
    isFetching: false,
    lists: {},
    selected: {
      id: null,
      data: {}
    },
    types: [],
    products: null,
    selectedProduct: {},
    error: "",
    eventStatus: {}
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENT_LIST:
      return {
        ...state,
        events: {
          ...state.events,
          lists: {
            ...state.events.lists,
            [action.filters.tabName]: []
          },
          isFetching: true,
          error: ""
        }
      };
    case FETCH_EVENT_PRODUCTS:
      return {
        ...state,
        events: {
          ...state.events,
          products: null,
          selectedProduct: {},
          isFetching: true
        }
      };
    case STORE_SELECTED_PRODUCT:
      return {
        ...state,
        events: {
          ...state.events,
          selectedProduct: action.selectedProduct
        }
      };
    case FETCH_EVENT_LIST_DONE: {
      return {
        ...state,
        events: {
          ...state.events,
          isFetching: false,
          error: "",
          lists: {
            ...state.events.lists,
            // tabName: "on-demand", "scheduled"
            [action.tabName]: action.events
          }
        }
      };
    }
    case FETCH_EVENT_DETAILS_DONE: {
      const { event } = action;
      return {
        ...state,
        events: {
          ...state.events,
          selected: {
            id: event.id,
            data: event
          }
        }
      };
    }
    case FETCH_EVENT_TYPES_DONE:
      return {
        ...state,
        events: {
          ...state.events,
          types: action.types
        }
      };
    case FETCH_EVENT_STATUS_DONE:
      return {
        ...state,
        events: {
          ...state.events,
          eventStatus: {
            startTime: action.payload.startTime,
            status: action.payload.status
          }
        }
      };
    case FETCH_EVENT_PRODUCTS_DONE:
      return {
        ...state,
        events: {
          ...state.events,
          products: action.products,
          isFetching: false
        }
      };
    case FETCH_EVENT_LIST_ERROR:
      return {
        ...state,
        events: {
          ...state.events,
          isFetching: false,
          lists: {},
          error: "There was an error fetching the events list"
        }
      };
    case FETCH_EVENT_PRODUCTS_ERROR:
      return {
        ...state,
        events: {
          ...state.events,
          products: [],
          selectedProduct: {},
          error: "There was an error fetching the event products",
          isFetching: false
        }
      };
    case CLEAR_EVENT_DETAILS: {
      return {
        ...state,
        events: {
          ...state.events,
          selected: {
            id: null,
            data: {}
          }
        }
      };
    }
    case CLEAR_EVENT_STATUS:
      return {
        ...state,
        events: {
          ...state.events,
          eventStatus: {}
        }
      };
    default:
      return state;
  }
};
